import React from 'react'

const Variables = () => {
  return (
    <>var</>
  )
}

export default Variables